import * as $ from "jquery";
import ProgressService from './progress-service';

export async function submitForm(formSelector, additionalData) {

    const tokenObject = await getCsrfToken()
    const sessionID = $('meta[name="fs-id"]').attr("content");
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": tokenObject.token
        }
    });
    let frm = $(formSelector);
    let url = frm.attr('data-static-endpoint') || '/postForm';
    if (sessionID) {
        url += '?session_id=' + sessionID;
    }

    let formData = new FormData(frm.get(0));
    additionalData.forEach(data => {
        formData.append(data.field, data.data)
    })

    return $.ajax({
        url: url,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        xhr: ProgressService.progress,
    }).then(result => {
        ProgressService.stopProgress();
        return result;
    }).catch(ex => {
        ProgressService.stopProgress();
        return ex;
    });
}

export async function getCsrfToken() :Promise<{token: string}>{

    const sessionID = $('meta[name="fs-id"]').attr("content");
    let url = '/csrf-token';
    if (sessionID) {
        url += '?session_id=' + sessionID;
    }

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
        }
    });

    return $.ajax({
        url: url,
        type: 'GET',
        success: function (response) {
            console.log(response);
            $('meta[name="csrf-token"]').attr('content', response.token)
            $('meta[name="fs-id"]').attr('content', response.fsId)
            return response.token
        }
    });
}


//    success: function(data) {
//        console.log(data);
//        if(data.hasOwnProperty('modalMessage')) {
//            //popup
//        } else if (data.hasOwnProperty('confirmMessage')) {
//            //popup

//        } else {
//            //window.location = data.redirectURL;
//        }
//    },
//    statusCode: {
//        200: function() {

//        },
//        422: function (data) {

//        },
//        403: function (data) {

//        },
//        500: function(data) {
//            alert(data.responseText);
//        }
//    }
//})
